import { getEventStore } from "@afas-doe-maar/models";
import { useLocalStorage } from "@afas-doe-maar/ui/useLocalStorage";
import { useEffect, useMemo } from "react";
import { EventStoreContext } from "./EventStoreContext";

export type EventStoreContextValue = ReturnType<typeof useContextValue>;

const LOCALSTORAGE_EVENT_ID_KEY = "waterbodies:eventId";

function useContextValue() {
  // `eventId` is stored in local storage so the user can continue where they left off if they
  // refresh the page
  const [eventId, setEventId] = useLocalStorage<string | null>(LOCALSTORAGE_EVENT_ID_KEY, null);

  // When the eventId changes, the eventStore is updated
  const eventStore = useMemo(() => getEventStore({ eventId }), [eventId]);

  useEffect(() => {
    console.log("eventKey", eventStore.eventKey);
  }, [eventStore.eventKey]);

  return useMemo(() => ({ eventStore, setEventId }), [eventStore, setEventId]);
}

export function EventStoreProvider({ children }: { children: React.ReactNode }) {
  const contextValue = useContextValue();
  return <EventStoreContext.Provider value={contextValue}>{children}</EventStoreContext.Provider>;
}
